export default "__VITE_ASSET__DcFwn1nn__"